<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"
                                           @doClear="initFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emSparePartsInventorySpiResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      with-custom-row-actions-first-column
                                      ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-sign-in"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="备件入库"
                                        @click="openInputDialog()">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-sign-out"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name custom-label="备件出库"
                                        @click="openOutputDialog()">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-shopping-cart"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('select')"
                                        show-name custom-label="批量备件出库"
                                        @click="openBatchOutputDialog()">
                                    </em-button>
                                    <em-button
                                        type="gotoChild"
                                        custom-icon="fa fa-th-list"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('select')"
                                        show-name custom-label="批量库存盘点"
                                        @click="openInventoryCheckDialog()">
                                    </em-button>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-edit"
                                            class="btn btn-outline-primary btn-sm"
                                            show-name custom-label="库存变动"
                                            @click="gotoInventoryChangeRecords(customRowScope.row)">
                                        </em-button>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-retweet"
                                            class="btn btn-outline-primary btn-sm"
                                            show-name custom-label="库存盘点"
                                            @click="gotoInventoryCheckRecords(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <!-- 入库对话框 -->
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="inputDialogVisible" title="备品备件入库"
                   width="30%"
                   @close='clearInputForm'>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-weight: bold">{{ this.currentForm.currentName }}</span>
                    <el-tag style="float: right; padding: 0px 10px 0px 10px">
                        当前库存量：{{ this.currentForm.currentQuantity }}
                    </el-tag>

                </div>
                <el-form ref="inputForm" :model="inputForm" :rules="inputRules" label-width="auto">
                    <el-form-item label="入库量" prop="inputQuantity">
                        <el-input v-model="inputForm.inputQuantity" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="入库时间" prop="inputTime">
                        <el-date-picker v-model="inputForm.inputTime" placeholder="未选默认当前时间入库" type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="inputForm.remark" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button @click="inputDialogVisible = false">取 消</el-button>
                <el-button :disabled="disableInput" type="primary" @click="storageInput()">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 出库对话框 -->
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="outputDialogVisible" title="备品备件出库"
                   width="30%"
                   @close='clearOutputForm'>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-weight: bold">{{ this.currentForm.currentName }}</span>
                    <el-tag style="float: right; padding: 0px 10px 0px 10px">
                        当前库存量：{{ this.currentForm.currentQuantity }}
                    </el-tag>
                </div>
                <div class="text item">
                    <el-form ref="outputForm" :model="outputForm" :rules="outputRules" label-width="auto">
                        <el-form-item label="出库量" prop="outputQuantity">
                            <el-input v-model="outputForm.outputQuantity" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="出库时间" prop="outputTime">
                            <el-date-picker v-model="outputForm.outputTime" placeholder="选择日期时间" type="datetime"
                                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="备件去向" prop="destination">
                            <el-input v-model="outputForm.destination" type="text"></el-input>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="outputForm.remark" type="textarea"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>

            <div slot="footer" class="dialog-footer">
                <el-button @click="outputDialogVisible = false">取 消</el-button>
                <el-button :disabled="disableOutput" type="primary" @click="storageOutput()">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 批量出库对话框 -->
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchOutputDialogVisible"
                   title="备品备件出库"
                   width="60%">
            <el-table :data="selectedBatchOutputData" border stripe>
                <!-- 如果不需要选择框，可以移除 type="selection" 这一列 -->
                <el-table-column type="text" align="center" width="1"></el-table-column>
                <el-table-column prop="id" label="ID" align="center" width="50"></el-table-column>
                <el-table-column prop="spiNameSpa" label="备件名称" align="center" width="200"></el-table-column>
                <el-table-column prop="spiQuantity" label="当前数量" align="center" width="100"></el-table-column>
                <el-table-column prop="outputQuantity" label="出库数量" align="center" width="100">
                    <template slot-scope="scope">
                        <el-input type="number" v-model="scope.row.outputQuantity"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="outputTime" label="出库时间" align="center" width="245">
                    <template slot-scope="scope">
                        <el-date-picker type="datetime" v-model="scope.row.outputTime"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="destination" label="备件去向" align="center" width="280">
                    <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.destination"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center">
                    <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.remark"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="batchOutputDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="batchOutput">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 库存盘点对话框 -->
        <!-- 统一一个库存量盘点对话框，屏蔽 -->
        <!--        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="inventoryCheckDialogVisible"-->
        <!--                   title="库存盘点"-->
        <!--                   width="30%"-->
        <!--                   @close='clearInventoryCheckForm'>-->
        <!--            <el-card class="box-card">-->
        <!--                <div slot="header" class="clearfix">-->
        <!--                    <span style="font-weight: bold">请录入盘点库存数量</span>-->
        <!--                    <el-tag style="float: right; padding: 0px 10px 0px 10px">-->
        <!--                        勾选盘点记录数：{{ this.checkedItems.length }}-->
        <!--                    </el-tag>-->
        <!--                </div>-->
        <!--                <el-form ref="inputForm" :model="inventoryCheckForm" :rules="inventoryCheckRules" label-width="auto">-->
        <!--                    <el-form-item label="盘点库存量" prop="inputQuantity">-->
        <!--                        <el-input v-model="inventoryCheckForm.checkQuantity" type="number"></el-input>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="盘点时间" prop="inputTime">-->
        <!--                        <el-date-picker v-model="inventoryCheckForm.checkTime" placeholder="未选默认当前时间盘点"-->
        <!--                                        type="datetime"-->
        <!--                                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="备注">-->
        <!--                        <el-input v-model="inventoryCheckForm.remark" type="textarea"></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </el-form>-->
        <!--            </el-card>-->
        <!--            <div slot="footer" class="dialog-footer">-->
        <!--                <el-button @click="inventoryCheckDialogVisible = false">取 消</el-button>-->
        <!--                <el-button :disabled="disableInventoryCheck" type="primary" @click="inventoryCheckCommit()">确 认-->
        <!--                </el-button>-->
        <!--            </div>-->
        <!--        </el-dialog>-->

        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="inventoryCheckDialogVisible"
                   title="库存盘点"
                   width="60%">
            <el-table :data="selectedBatchCheckData" border stripe>
                <!-- 如果不需要选择框，可以移除 type="selection" 这一列 -->
                <el-table-column type="text" align="center" width="1"></el-table-column>
                <el-table-column prop="ids" label="ID" align="center" width="50"></el-table-column>
                <el-table-column prop="spiNameSpa" label="备件名称" align="center" width="200"></el-table-column>
                <el-table-column prop="spiQuantity" label="当前库存数量" align="center" width="120"></el-table-column>
                <el-table-column prop="spiQuantity" label="盘点库存数量" align="center" width="120">
                    <template slot-scope="scope">
                        <el-input type="number" v-model="scope.row.checkQuantity"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="outputTime" label="盘点时间" align="center" width="245">
                    <template slot-scope="scope">
                        <el-date-picker type="datetime" v-model="scope.row.checkTime"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center">
                    <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.remark"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="inventoryCheckDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="inventoryCheckCommit">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author thq
// Date 2024-05-26 10:25:25

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emApiMixin from "@/mixin/em/common/api";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "emSparePartsInventorySpiListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emApiMixin, emTableCheckedMixin, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            inputDialogVisible: false,
            outputDialogVisible: false,
            batchOutputDialogVisible: false,
            inventoryCheckDialogVisible: false,
            selectedBatchOutputData: [],
            selectedBatchCheckData: [],
            selectedWarehouseList: [],
            currentForm: {
                currentName: null,
                currentQuantity: null
            },
            inputForm: {
                id: '',
                inputQuantity: '',
                inputTime: '',
                remark: ''
            },
            outputForm: {
                id: '',
                warehouseId: '',
                outputQuantity: '',
                outputTime: '',
                destination: '',
                remark: ''
            },
            batchOutputForm: {
                id: '',
                warehouseId: '',
                spiName: '',
                outputQuantity: '',
                outputTime: '',
                destination: '',
                remark: ''
            },
            inventoryCheckForm: {
                ids: '',
                checkQuantity: '',
                checkTime: '',
                remark: ''
            },
            warehousePermissionForm: {
                id: null,
                warehouseId: null
            },
            inputRules: {
                inputQuantity: [{required: true, message: '入库量不能为空'}],
            },
            outputRules: {
                outputQuantity: [{required: true, message: '出库量不能为空'}],
                destination: [{required: true, message: '备件去向不能为空'}],
            },
            inventoryCheckRules: {
                checkQuantity: [{required: true, message: '盘点库存量不能为空'}],
            }
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            return this.$store.state[this.modelName]["checkedItems"];
        },
        checkedEntity() {
            return this.$store.state[this.modelName]["entity"];
        },

        selectIds() {
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
        disableInput() {
            return this.inputForm.inputQuantity <= 0;
        },
        disableOutput() {
            return this.outputForm.outputQuantity <= 0;
        },
        disableInventoryCheck() {
            const quantity = this.inventoryCheckForm.checkQuantity;
            return quantity === null || quantity === '' || quantity === undefined || quantity < 0;
        }
    },
    methods: {
        openInputDialog() {
            this.getCurrentForm();
            this.inputDialogVisible = true;
        },
        openOutputDialog() {
            this.getCurrentForm();
            this.outputDialogVisible = true;
        },
        getCurrentForm() {
            if (this.checkedRows && this.checkedRows.length === 1) {
                this.currentForm = {
                    currentName: this.checkedRows[0].spiNameSpa,
                    currentQuantity: this.checkedRows[0].spiQuantity
                };
            }
        },
        openBatchOutputDialog() {
            this.selectedWarehouseList = this.checkedRows.map(item => {
                return {
                    id: item.id,
                    warehouseId: item.spiWarehouseId
                }
            });
            //填充勾选数据行到selectedBatchOutputData
            this.selectedBatchOutputData = this.checkedRows.map(item => {
                return {
                    id: item.id,
                    warehouseId: item.spiWarehouseId,
                    spiNameSpa: item.spiNameSpa,
                    spiQuantity: item.spiQuantity,
                    outputQuantity: '',
                    outputTime: '',
                    destination: '',
                    remark: ''
                }
            });
            this.batchOutputDialogVisible = true;
        },
        openInventoryCheckDialog() {
            this.selectedWarehouseList = this.checkedRows.map(item => {
                return {
                    id: item.id,
                    warehouseId: item.spiWarehouseId
                }
            });
            //填充勾选数据行到selectedBatchCheckData
            this.selectedBatchCheckData = this.checkedRows.map(item => {
                return {
                    ids: item.id,
                    spiNameSpa: item.spiNameSpa,
                    spiQuantity: item.spiQuantity,
                    checkQuantity: '',
                    checkTime: '',
                    remark: ''
                }
            });
            this.inventoryCheckDialogVisible = true;
        },
        clearInputForm() {
            this.inputForm.id = '';
            this.inputForm.inputQuantity = '';
            this.inputForm.inputTime = '';
            this.inputForm.remark = '';
            this.$refs["inputForm"].resetFields();
        },
        clearOutputForm() {
            this.inputForm.id = '';
            this.outputForm.outputQuantity = '';
            this.outputForm.outputTime = '';
            this.outputForm.destination = '';
            this.outputForm.remark = '';
            this.$refs["outputForm"].resetFields();
        },
        //入库
        storageInput() {
            if (this.selectIds) {

                //绑定数据，准备提交
                this.warehousePermissionForm.id = this.selectIds
                this.warehousePermissionForm.warehouseId = this.checkedEntity.spiWarehouseId

                //首先判断库管权限
                let _url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/inventoryChangePermissionResult`
                this.$_emApiMixin_post(_url, this.warehousePermissionForm)
                    .then(requestPermission => {
                        if (requestPermission.status === 200) {
                            if (requestPermission.data) {
                                //异步调用内，返回有权限再执行入库
                                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/storageInput`
                                //绑定id
                                this.inputForm.id = this.selectIds
                                this.$_emApiMixin_post(url, this.inputForm)
                                    .then(request => {
                                        if (request.status === 200) {
                                            this.$message({
                                                message: "备品备件入库成功",
                                                type: "success",
                                            });
                                            this.inputDialogVisible = false;
                                            this.$refs["emListFilter"].doQuery();
                                        } else {
                                            this.$message({
                                                message: "备品备件入库失败",
                                                type: "error",
                                            });
                                        }
                                    })
                            } else {
                                this.$message({
                                    message: "您不是库管员，没有操作权限，请检查勾选库房的记录是否正确！",
                                    type: "error",
                                });
                            }
                        } else {
                            this.$message({
                                message: "库存管理鉴权失败，请联系系统管理员排查！",
                                type: "error",
                            });
                        }
                    })
            }
        },
        //出库
        storageOutput() {
            if (this.selectIds) {
                //判断库存量是否足以出库操作
                if (this.outputForm.outputQuantity > this.checkedEntity.stiQuantity) {
                    this.$message({
                        message: "库存数量不足，出库操作失败",
                        type: "error",
                    });
                    return;
                }

                //绑定数据，准备提交
                this.warehousePermissionForm.id = this.selectIds
                this.warehousePermissionForm.warehouseId = this.checkedEntity.spiWarehouseId

                this.outputForm.id = this.selectIds

                //首先判断库管权限
                let _url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/inventoryChangePermissionResult`
                this.$_emApiMixin_post(_url, this.warehousePermissionForm)
                    .then(requestPermission => {
                        if (requestPermission.status === 200) {
                            if (requestPermission.data) {
                                //异步调用内，返回有权限再执行出库
                                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/storageOutput`
                                this.$_emApiMixin_post(url, this.outputForm)
                                    .then(request => {
                                        if (request.status === 200) {
                                            this.$message({
                                                message: "备品备件出库成功",
                                                type: "success",
                                            });
                                            this.outputDialogVisible = false;
                                            this.$refs["emListFilter"].doQuery();
                                        } else {
                                            this.$message({
                                                message: "备品备件出库失败",
                                                type: "error",
                                            });
                                        }
                                    })
                            } else {
                                this.$message({
                                    message: "您不是库管员，没有操作权限，请检查勾选库房的记录是否正确！",
                                    type: "error",
                                });
                            }
                        } else {
                            this.$message({
                                message: "库存管理鉴权失败，请联系系统管理员排查！",
                                type: "error",
                            });
                        }
                    })
            }
        },

        //批量出库
        batchOutput() {
            const invalidQuantityItems = this.selectedBatchOutputData.filter(item => item.outputQuantity === null || item.outputQuantity === '' || item.outputQuantity <= 0);
            if (invalidQuantityItems.length > 0) {
                this.$message({
                    message: "请检查批量出库列表，出库数量不能为空且必须大于0！",
                    type: "error",
                });
                return;
            }
            const invalidDestinationItems = this.selectedBatchOutputData.filter(item => item.destination === null || item.destination === '');
            if (invalidDestinationItems.length > 0) {
                this.$message({
                    message: "请检查批量出库列表，请填写备件出库去向！",
                    type: "error",
                });
                return;
            }
            // // Convert outputTime to DateString
            this.selectedBatchOutputData.forEach(item => {
                if (item.outputTime) {
                    const date = new Date(item.outputTime);
                    item.outputTime = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                }
            });

            //首先判断库管权限
            let _url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/inventoryChangePermissionBatchResult`
            this.$_emApiMixin_post(_url, this.selectedWarehouseList)
                .then(requestPermission => {
                    if (requestPermission.status === 200) {
                        if (requestPermission.data) {
                            //异步调用内，返回有权限再执行批量出库
                            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/storageBatchOutput`
                            this.$_emApiMixin_post(url, this.selectedBatchOutputData)
                                .then(request => {
                                    if (request.status === 200) {
                                        this.$message({
                                            message: "批量出库成功",
                                            type: "success",
                                        });
                                        this.batchOutputDialogVisible = false;
                                        this.$refs["emListFilter"].doQuery();
                                    } else {
                                        this.$message({
                                            message: "批量出库失败",
                                            type: "error",
                                        });
                                    }

                                })
                        } else {
                            this.$message({
                                message: "您不是库管员，没有操作权限，请检查勾选库房的记录是否正确！",
                                type: "error",
                            });
                        }
                    } else {
                        this.$message({
                            message: "库存管理鉴权失败，请联系系统管理员排查！",
                            type: "error",
                        });
                    }
                })
        },
        //库存盘点
        inventoryCheckCommit() {
            if (this.selectIds) {
                const invalidQuantityItems = this.selectedBatchCheckData.filter(item => item.checkQuantity === null || item.checkQuantity === '' || item.checkQuantity < 0);
                if (invalidQuantityItems.length > 0) {
                    this.$message({
                        message: "请检查批量盘库列表，盘库数量不能为空或负数！",
                        type: "error",
                    });
                    return;
                }
                // // Convert outputTime to DateString
                this.selectedBatchCheckData.forEach(item => {
                    if (item.checkTime) {
                        const date = new Date(item.checkTime);
                        item.checkTime = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                    }
                });

                //首先判断库管权限
                let _url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/inventoryChangePermissionBatchResult`
                this.$_emApiMixin_post(_url, this.selectedWarehouseList)
                    .then(requestPermission => {
                        if (requestPermission.status === 200) {
                            if (requestPermission.data) {
                                //异步调用内，返回有权限再执行批量出库
                                //单一量批量盘库方案，暂时屏蔽
                                // let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/inventoryCheck`
                                // //绑定id
                                // this.inventoryCheckForm.ids = this.selectIds
                                // this.$_emApiMixin_post(url, this.inventoryCheckForm)

                                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/batchEditInventoryCheck`
                                this.$_emApiMixin_post(url, this.selectedBatchCheckData)
                                    .then(request => {
                                        if (request.status === 200) {
                                            this.$message({
                                                message: "库存盘点成功",
                                                type: "success",
                                            });
                                            this.inventoryCheckDialogVisible = false;
                                            this.$refs["emListFilter"].doQuery();
                                        } else {
                                            this.$message({
                                                message: "库存盘点失败",
                                                type: "error",
                                            });
                                        }

                                    })
                            } else {
                                this.$message({
                                    message: "您不是库管员，没有操作权限，请检查勾选库房的记录是否正确！",
                                    type: "error",
                                });
                            }
                        } else {
                            this.$message({
                                message: "库存管理鉴权失败，请联系系统管理员排查！",
                                type: "error",
                            });
                        }
                    })
            }
        },
        gotoInventoryChangeRecords(row) {
            this.$_emGotoMixin_gotoHolderList("emSppInventoryChangeIch"
                , {ichIdSpiFilter: row.id}
                , {ichIdSpiFilter: row.id}, false, {})
        },
        gotoInventoryCheckRecords(row) {
            this.$_emGotoMixin_gotoHolderList("emSparePartsInventoryCheckSic"
                , {sicIdSpiFilter: row.id}
                , {sicIdSpiFilter: row.id}, false, {})
        },
        initFilter() {
            //清除设备档案跳转绑定的查询条件，清除按钮无法清空的问题
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('spiUsedDeviceFilter', null);
        }
    }
};
</script>